import { useNavigate, type NavigateFunction } from "react-router-dom";
import { useRoutes } from "react-router-dom";
import { useEffect } from "react";
import routes from "./config";

let navigateResolver: (navigate: ReturnType<typeof useNavigate>) => void;

declare global {
  interface Window {
    REACT_APP_NAVIGATE: ReturnType<typeof useNavigate>;
  }
}

export const navigatePromise = new Promise<NavigateFunction>((resolve) => {
  navigateResolver = resolve;
});

export function AppRoutes() {
  const element = useRoutes(routes);
  const navigate = useNavigate();

  useEffect(() => {
    window.REACT_APP_NAVIGATE = navigate;
    navigateResolver(window.REACT_APP_NAVIGATE);
  }, [navigate]);

  // Handle admin access shortcuts — runs once on mount
  useEffect(() => {
    const searchParams = new URLSearchParams(window.location.search);

    // Hash-based admin access (#admin) — some browsers preserve it
    if (window.location.hash && window.location.hash.startsWith("#admin")) {
      navigate("/admin", { replace: true });
      return;
    }

    // Query-param admin access (?a=1) — reliable in WhatsApp browser
    if (searchParams.get("a") === "1") {
      // Small delay ensures React Router is fully initialized
      const timer = setTimeout(() => {
        navigate("/admin", { replace: true });
      }, 0);
      return () => clearTimeout(timer);
    }
  }, []); // Empty deps — runs once on mount

  return element;
}